module.exports = __webpack_public_path__ + "static/media/modal_lpg.33682d91.png";